import { render, staticRenderFns } from "./elearea2.vue?vue&type=template&id=50dfa570&scoped=true&"
import script from "./elearea2.vue?vue&type=script&lang=js&"
export * from "./elearea2.vue?vue&type=script&lang=js&"
import style0 from "./elearea2.vue?vue&type=style&index=0&id=50dfa570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dfa570",
  null
  
)

export default component.exports